import React, { Suspense, useState } from "preact/compat";
import { signal } from "@preact/signals";
import Cookies from 'js-cookie';

import { Header } from "./components/📰Templates/Betslip/Header/Header";
import { Main } from "./components/📰Templates/Betslip/Main/Main";

import { translation } from './locales/en/translation'; 
import { getDataAttributes } from "./helper/DataAttributeHelper";
import { apiService } from "./api/ApiService";
import { ToggleModal } from "./components/💠Molecules/Betslip/Modal/ToggleModal";
import { BetSlipVm } from "./types/BetSlipVm";
import { schema } from "./config";
import { currencyFormatter } from "./helper/currencyFormatter";
import { eventDispatcher } from "./helper/aa-event-dispatcher";

const cookieName = signal<string>('');
const cookieExpiration = signal<number>(30);
const site = signal<string>('covers');

const typeTrigger = signal<string>('none');
const tabSelected = signal<string>(translation.tabs.tab1);
const openModal = signal<boolean>(false);
const betCounter = signal<number>(0);
const data = signal<BetSlipVm>(new BetSlipVm());


const modalValue = signal<any>([]);
const scrapeData = signal<any>({});
const activeParly = signal<number[]>([]);
const expandBetSlip = signal<boolean>(false);

const wgStValues = signal<string[]>([]);
const wgPrValue = signal<string>(currencyFormatter.format(10.00));

const systemError = signal('');

function BetSlip() {
    const [dBet, setDBet] = useState(data.value);
    const [selectedParly, setSelectedParly] = useState<number[]>(activeParly.value);
    const [wagersSt, setWagersSt] = useState<string[]>(wgStValues.value);
    const [wagersPr, setWagersPr] = useState(wgPrValue.value);

    setWagersSt(wgStValues.value)

    const closeModal = () => {
        openModal.value = false;

        expandBetSlip.value ? document.body.classList.add("bs-open", "modal-open") : document.body.classList.remove("bs-open", "modal-open");
    }

    const handleChange = () => {
        expandBetSlip.value = !expandBetSlip.value;
        const text = expandBetSlip.value ? "expand" : "minimize";
        
        expandBetSlip.value ? document.body.classList.add("bs-open", "modal-open") : document.body.classList.remove("bs-open", "modal-open");
        eventDispatcher("bet-slip", "expand/minimize", "Container", "Button", text);
    }
    
    const addBetslip = () => {
        if (typeTrigger.value === 'modal' && !data.value.isDuplicateBet(modalValue.value) && betCounter.value < 13) {
            data.value.addBet(modalValue.value)
            wgStValues.value = data.value.getStraightWagers()
            setDBet(data.value)
            setWagersSt(wgStValues.value)

            const tempSl = selectedParly;
            tempSl[betCounter.value] = betCounter.value;
            setSelectedParly(tempSl)
            activeParly.value = tempSl;

            betCounter.value = data.value.getTotalBets();
            if (betCounter.value > 1) {
                tabSelected.value = translation.tabs.tab2;
            }
            setCookie(data.value.getCookieBets())
        }
        expandBetSlip.value = !expandBetSlip.value;
        openModal.value = !openModal.value;

        const text = expandBetSlip.value ? "expand" : "minimize";
        expandBetSlip.value ? document.body.classList.add("bs-open", "modal-open") : document.body.classList.remove("bs-open", "modal-open");

        eventDispatcher("bet-slip", "expand/minimize", "Container", "Button", text);

    }

    const removeGame = (index?: number | null | undefined, indexList?: number[] | null | undefined) => { 
        const tempWSl = [...wagersSt];
        const tempParlay = [...selectedParly];

        if (index !== undefined && index !== null) {
            // const elementSelected = document.querySelectorAll('[data-game="'+data.value.bets[index].game.gameId+'"]')
            //       elementSelected.forEach(item => item.classList.remove("selected"));
            tempWSl.splice(index, 1);
            tempParlay.splice(index, 1);
            
            data.value.removeBet(index);
        }

        if (indexList !== undefined && indexList !== null) {
            indexList.forEach(indx => {
                const elementSelected = document.querySelectorAll('[data-game="'+data.value.bets[indx].game.gameId+'"]')
                elementSelected.forEach(item => item.classList.remove("selected"));
            })
            indexList.reverse().map(index => {
                tempWSl.splice(index, 1);
            })
            indexList.reverse().map(item => tempParlay.splice(item, 1))
            
            data.value.removeMultipleBets(indexList);
        }

        setWagersSt(tempWSl)
        wgStValues.value = tempWSl;
        setDBet(data.value)

        setCookie(data.value.getCookieBets())
        betCounter.value = data.value.getTotalBets();

        setSelectedParly(tempParlay)
        activeParly.value = tempParlay;

        if (betCounter.value < 2) {
            tabSelected.value = translation.tabs.tab1;
        }

        return tempParlay;
    }

    const removeOutdatedGames = () => {
        const gameOutdatedList = data.value.getOutadedGamesIndex();

        eventDispatcher("bet-slip", "clear", "Container", "Button", "onClick"); 

        removeGame(null, gameOutdatedList);
    }

    const handleUpdateStraightWager = (selectIndex: number, q: string) => {
        data.value.updateStraightWager(selectIndex, q)
        const tempWg = wagersSt.map((vals, index) => {
            if (selectIndex === index) {
                return q;
            } else {
                return vals;
            }
          });

        wgStValues.value = tempWg
        setWagersSt(tempWg)
        setDBet(data.value)
        setCookie(data.value.getCookieBets())

        return wagersSt;
    };

    const handleUpdateParlayWager = (q: string) => {
        data.value.updateParlayWager(q)
        setWagersPr(q)
        setDBet(data.value)
        setCookie(data.value.getCookieBets())
        
        return wagersPr
    };

    const handleTabUpdate = (target: string) => {
        tabSelected.value = target;
    }
    
    const handleSelectedParlay = (selectIndex: number) => {
        data.value.updateSelectedLeg(selectIndex)
        const tmp = selectedParly;      
        tmp[selectIndex] = Number(tmp[selectIndex] === -1 ? selectIndex : -1);

        setSelectedParly(tmp);
        activeParly.value = tmp;

        setCookie(data.value.getCookieBets())
        return tmp;
    }

    return (
        <Suspense fallback={<p>Loading</p>}>
            {typeTrigger.value === 'modal' ?
                <ToggleModal 
                    t={translation} 
                    site={site.value}
                    toggle={openModal.value} 
                    betData={modalValue.value} 
                    addBs={dBet.isDuplicateBet(modalValue.value)}
                    onClick={addBetslip} 
                    onClose={closeModal} />
            : '' }
            
            <div className={`${site.value}-slip`}>
                <div className={`betslip-container position-fixed py-3 bottom-0 right-0 rounded-top bg-white ${expandBetSlip.value ? 'show' : 'z-4'}`}>
                    <Header 
                        t={translation.header.tagline} 
                        site={site.value}
                        totalC={betCounter.value}
                        onClick={handleChange} />
                    <Main 
                        t={translation}
                        site={site.value}
                        stWager={wgStValues.value}
                        prWager={wgPrValue.value}
                        betData={dBet} 
                        system={systemError.value}
                        removeTheGame={removeGame}
                        tabState={tabSelected.value}
                        prSelected={activeParly.value}
                        removeOldGames={removeOutdatedGames}
                        handleUpdateStraightWager={handleUpdateStraightWager}
                        updateParlayWager={handleUpdateParlayWager}
                        updateTab={handleTabUpdate}
                        updateSelectdParlay={handleSelectedParlay} />
                </div>
                <div className={`modal ${expandBetSlip.value ? 'show' : ''}`} onClick={handleChange}></div>
            </div>
        </Suspense>
    )
}

export const App = <BetSlip />;



/* ----------------------------------------------------------------------------
        (addDataToBetslip) This function is called in the 
        index.js (setupBetslip function) 
        when the cookie exist.
        
        The goal of the function is 
        1. Parse the cookie (cover the values to JSON)
        2. Loop through the cookie values and map them to the API response
        3. Set the retrieved data in the global signal variables
---------------------------------------------------------------------------- */

export const addDataToBetslip = async (config: schema, cookieBetName: string, cookieValue?: string) => {
    cookieName.value = cookieBetName;
    const valCookie = cookieValue ? JSON.parse(cookieValue) : null;
    
    if (!valCookie) {
        return;
    }

    const responses = await Promise.all(
        valCookie.bets.map(async (dataVals: any) => {
            
            apiService(dataVals.dataAttributes)
            .then(function (val) {
                if (val) {
                    if (betCounter.value < 13) {
                        data.value.addBet(val)       
                        
                        data.value.updateStraightWager(betCounter.value, dataVals.straightWager)
                        wgStValues.value = data.value.getStraightWagers()
                        dataVals.isActiveLeg !== null && !dataVals.isActiveLeg ? data.value.updateSelectedLeg(betCounter.value) : null;
            
                        activeParly.value[betCounter.value] = dataVals.isActiveLeg !== null && dataVals.isActiveLeg ? betCounter.value : -1;
            
                        betCounter.value = data.value.getTotalBets();
                    }

                    if (betCounter.value > 1) {
                        tabSelected.value = translation.tabs.tab2;
                    }
                }else if (!val && data.value.getTotalBets() < 1) {
                    systemError.value = translation.system_messages.api_connection.heading;
                    return;
                }
            })
        })
    )
    data.value.updateParlayWager(valCookie.parlayWager)
    wgPrValue.value = valCookie.parlayWager
}

/* ----------------------------------------------------------------------------      
        (getData) This function is called in the 
        index.js (setupBetslip function)
        when the user clicks on a table cell.
        
        The goal of the function is 
        1. get the attribute values from the clicked element
        2. Retrieve the odds data through the API service helper
        3. Set the retrieved data in the global signal variables
---------------------------------------------------------------------------- */

export const getData = (event: any, config: schema, cookieBetName: string) => {
    event.preventDefault();
    cookieName.value = cookieBetName;
    const triggerType = config.bsTrigger ? config.bsTrigger : 'none';
    cookieExpiration.value = config.bsCookieLength ? Number(config.bsCookieLength) : 30

    site.value = config.bsSport ? config.bsSport.toString() : 'covers';

    const nodeUrl = event.target.getAttribute(config.bsAPIUrl) === null ? event.target.parentNode : event.target;
    
    scrapeData.value = getDataAttributes(nodeUrl);
    
    apiService(scrapeData.value)
        .then(function (val) {
            typeTrigger.value = triggerType;

            if (val) {
                openModal.value = true;
                modalValue.value = val;
                // const elementSelected = nodeUrl.parentNode.parentNode 
                // elementSelected.classList.add("selected")
                    
                if (typeTrigger.value === 'betslip' && !data.value.isDuplicateBet(modalValue.value) && betCounter.value < 13) {
                    expandBetSlip.value = true;
                    openModal.value = false;

                    data.value.addBet(modalValue.value)
                    wgStValues.value = data.value.getStraightWagers()
        
                    activeParly.value[betCounter.value] = betCounter.value;
        
                    betCounter.value = data.value.getTotalBets();
                    
                    if (betCounter.value > 1) {
                        tabSelected.value = translation.tabs.tab2;
                    }
                    document.body.classList.add("bs-open", "modal-open");
                    setCookie(data.value.getCookieBets())
                    eventDispatcher("bet-slip", "expand/minimize", "Container", "Button", "expand");
                }
            }else if (!val && data.value.getTotalBets() < 1) {
                systemError.value = translation.system_messages.api_connection.heading;
                window.open(nodeUrl.getAttribute('href'), '_self');
                
                return;
            }
        })
}

/* ----------------------------------------------------------------------------
        (setCookie) Function that clears the cookie, 
        and converts the JSON to 
        string to set the cookie with the odds data 
---------------------------------------------------------------------------- */

function setCookie(data: any) {
    Cookies.remove(cookieName.value)

    const valueString = JSON.stringify(data);
    
    Cookies.set(
        cookieName.value, 
        valueString, 
        { 
            expires: cookieExpiration.value, 
            secure: true, 
            sameSite: 'strict' 
        }
    )
    
    return;
}